import React from 'react';
import PropTypes from 'prop-types';
import { seasonalPerks, annualPerks } from './constants';
import { makeList } from '../../helpers';
import { Plans, NUMBER_OF_SEASONS_PER_YEAR } from '../constants';

const PerksList = ({ selected, showAdditionalPerks, annualPrice, seasonalPrice }) => {
  const currentList =
    selected === Plans.SEASONAL
      ? makeList(seasonalPerks, [], showAdditionalPerks)
      : makeList(annualPerks, [], showAdditionalPerks);
  const annualPricePerSeason = parseFloat(annualPrice) / NUMBER_OF_SEASONS_PER_YEAR;
  const formattedAnnualPricePerSeason = `$${Math.floor(annualPricePerSeason * 100) / 100} `;

  return (
    <>
      <div className="list-title-container">
        <h2>
          {selected === Plans.SEASONAL ? 'Seasonal ' : 'Annual '}
          Subscription
        </h2>
        <h4>
          {selected === Plans.SEASONAL ? `$${seasonalPrice} ` : formattedAnnualPricePerSeason}/ box
        </h4>
      </div>
      <div className="list-container">
        <ul className="perks-list">
          {currentList.slice(0, Math.floor(currentList.length / 2)).map(({ label, check }) => (
            <li key={label} className="perk">
              <i className={`far ${check ? 'fa-check' : 'fa-times'}`} />
              {label}
            </li>
          ))}
        </ul>
        <ul className="perks-list">
          {currentList
            .slice(Math.floor(currentList.length / 2), currentList.length)
            .map(({ label, check }) => (
              <li key={label} className="perk">
                <i className={`far ${check ? 'fa-check' : 'fa-times'}`} />
                {label}
              </li>
            ))}
        </ul>
      </div>
    </>
  );
};

PerksList.defaultProps = {
  selected: Plans.SEASONAL,
  showAdditionalPerks: false,
};

PerksList.propTypes = {
  selected: PropTypes.string,
  showAdditionalPerks: PropTypes.bool,
};

export default PerksList;
